import { Card, Tab, Tabs } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import AddAward from "./AddAward";
import AddPastGlimpse from "./AddPastGlimpse";
import HelperService from "../../utility/HelperService";
// import AddAcademy from "./AddAcademy";
// import AddAcademyEvetnGallery from "./AddAcademyEvetnGallery";
const Award = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [showPastGlimpseModal, setshowPastGlimpseModal] = useState(false);
  const [editingPastGlimpse, seteditingPastGlimpse] = useState<any>(null);
  const [PastGlimpseMode, setPastGlimpseMode] = useState<"add" | "edit">("add");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `award/getAward`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        //  toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const reorderPastGlimpse = (fromIndex: number, toIndex: number) => {
    if (fromIndex === toIndex) return;

    const updatedEvents = [...data.past_glimpses];
    const [moved] = updatedEvents.splice(fromIndex, 1);
    updatedEvents.splice(toIndex, 0, moved);

    const body = new FormData();
    body.append("past_glimpses", JSON.stringify(updatedEvents));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `award/addPastGlimpse`,
      body,
    })
      .then(() => {
        getData();
      })
      .catch(() => {
        toast.error("Failed to reorder past glimpse");
      });
  };
  const isValidYouTubeUrl = (url?: string) => {
    if (!url) return false;
    return /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/.test(
      url,
    );
  };

  //  const getYouTubeEmbedUrl = (url?: string) => {
  //   if (!url) return "";
  //   const match = url.match(
  //     /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  //   );

  //   return match
  //     ? `https://www.youtube.com/embed/${match[1]}?controls=1&modestbranding=1&rel=0`
  //     : "";
  // };
  const getYouTubeEmbedUrl = (url?: string) => {
    if (!url) return "";

    const match = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );

    return match
      ? `https://www.youtube-nocookie.com/embed/${match[1]}?controls=0&rel=0`
      : "";
  };

  return (
    <>
      <AddAward
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />
      <AddPastGlimpse
        show={showPastGlimpseModal}
        handleClose={() => {
          setshowPastGlimpseModal(false);
          getData();
        }}
        data={data}
        event={editingPastGlimpse}
        mode={PastGlimpseMode}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="page-title">Excellence Award</div>
          <div>
            <Tabs defaultActiveKey="info" className="mt-3">
              <Tab eventKey="info" title="Info" className=" p-3">
                {isLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: 100 }}
                  >
                    <span
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="page-title">Award</div>
                      {pagePermission.canAdd && (
                        <CustomButton
                          isLoading={false}
                          label={data ? "Edit" : "Add"}
                          onClick={() => {
                            setShowAddModal(true);
                          }}
                          style={{ width: 100 }}
                        />
                      )}
                    </div>
                    {data?.logo && (
                      <div className="mb-2 mt-2">
                        <img
                          src={data.logo}
                          alt="Past Glimpse"
                          style={{
                            maxWidth: "300px",
                            maxHeight: "300px",
                            width: "100%",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    )}
                    <strong>Title</strong>
                    {data?.title && <div>{data.title}</div>}

                    <strong>Description</strong>
                    {data?.description && (
                      <div className="ql-snow">
                        <div
                          className="mb-4 px-0 ql-editor"
                          dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(data.description) }}
                        />
                      </div>
                    )}

                    <strong>Next Award Date</strong>

                    {data?.next_award_date && <div>{data.next_award_date}</div>}
                    {data?.past_winners && data.past_winners.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Categories</h5>

                        {/* ✅ FLEX WRAPPER */}
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 20,
                          }}
                        >
                          {data.categories.map((item: any, index: number) => {
                            const isPdf = item.file
                              ?.toLowerCase()
                              .endsWith(".pdf");

                            return (
                              <a
                                key={index}
                                href={item.file}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  width: 320, // 👈 fixed width = side by side
                                  textDecoration: "none",
                                  background: "#fff",
                                  borderRadius: 16,
                                  border: "1px solid #e5e5e5",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                                  padding: 16,
                                  color: "#000",
                                  display: "block",
                                  transition: "transform 0.2s ease",
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(-4px)")
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(0)")
                                }
                              >
                                {/* 🔹 TOP ICON BOX */}
                                <div
                                  style={{
                                    background: "#f4fbff",
                                    borderRadius: 12,
                                    padding: "20px 12px",
                                    textAlign: "center",
                                    marginBottom: 14,
                                  }}
                                >
                                  <img
                                    src={
                                      isPdf
                                        ? "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"
                                        : "https://cdn-icons-png.flaticon.com/512/337/337932.png"
                                    }
                                    alt="File"
                                    style={{
                                      width: 42,
                                      height: 42,
                                      marginBottom: 8,
                                    }}
                                  />

                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 14,
                                    }}
                                  >
                                    {item.name || "View File"}
                                  </div>
                                </div>

                                {/* 🔹 FILE NAME */}
                                {item.name && (
                                  <div
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 600,
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                )}
                              </a>
                            );
                          })}
                        </div>
                      </>
                    )}

                    {data?.past_winners && data.past_winners.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Past Winners</h5>

                        {/* ✅ FLEX WRAPPER */}
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 20,
                          }}
                        >
                          {data.past_winners.map((item: any, index: number) => {
                            const isPdf = item.file
                              ?.toLowerCase()
                              .endsWith(".pdf");

                            return (
                              <a
                                key={index}
                                href={item.file}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  width: 320, // 👈 fixed width = side by side
                                  textDecoration: "none",
                                  background: "#fff",
                                  borderRadius: 16,
                                  border: "1px solid #e5e5e5",
                                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                                  padding: 16,
                                  color: "#000",
                                  display: "block",
                                  transition: "transform 0.2s ease",
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(-4px)")
                                }
                                onMouseLeave={(e) =>
                                (e.currentTarget.style.transform =
                                  "translateY(0)")
                                }
                              >
                                {/* 🔹 TOP ICON BOX */}
                                <div
                                  style={{
                                    background: "#f4fbff",
                                    borderRadius: 12,
                                    padding: "20px 12px",
                                    textAlign: "center",
                                    marginBottom: 14,
                                  }}
                                >
                                  <img
                                    src={
                                      isPdf
                                        ? "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg"
                                        : "https://cdn-icons-png.flaticon.com/512/337/337932.png"
                                    }
                                    alt="File"
                                    style={{
                                      width: 42,
                                      height: 42,
                                      marginBottom: 8,
                                    }}
                                  />

                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 14,
                                    }}
                                  >
                                    {item.name || "View File"}
                                  </div>
                                </div>

                                {/* 🔹 FILE NAME */}
                                {item.name && (
                                  <div
                                    style={{
                                      fontSize: 13,
                                      fontWeight: 600,
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                )}
                              </a>
                            );
                          })}
                        </div>
                      </>
                    )}

                    {Array.isArray(data?.videos) && data.videos.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Award Videos</h5>

                        <div className="row">
                          {data.videos
                            .map((v: any) =>
                              typeof v === "string" ? v : v?.url,
                            )
                            .filter((url: string) => isValidYouTubeUrl(url))
                            .slice(0, 2)
                            .map((url: string, index: number) => {
                              const embedUrl = getYouTubeEmbedUrl(url);
                              if (!embedUrl) return null;

                              return (
                                <div className="col-md-6 mb-3" key={index}>
                                  <div
                                    className="border rounded p-2"
                                    style={{
                                      height: 280,
                                      overflow: "hidden",
                                    }}
                                  >
                                    <iframe
                                      width="100%"
                                      height="260"
                                      src={embedUrl}
                                      title={`Award Video ${index + 1}`}
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                      style={{ borderRadius: 8 }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                        </div>

                        {/* MORE VIDEOS */}
                        {data.videos.length > 2 && (
                          <>
                            <h6 className="mt-3 mb-2">More Videos</h6>
                            <div className="d-flex flex-wrap gap-3">
                              {data.videos
                                .map((v: any) =>
                                  typeof v === "string" ? v : v?.url,
                                )
                                .filter((url: string) => isValidYouTubeUrl(url))
                                .slice(2)
                                .map((url: string, index: number) => {
                                  const embedUrl = getYouTubeEmbedUrl(url);
                                  if (!embedUrl) return null;

                                  return (
                                    <div
                                      key={index}
                                      className="border rounded p-2"
                                      style={{ width: 280 }}
                                    >
                                      <iframe
                                        width="100%"
                                        height="160"
                                        src={embedUrl}
                                        title={`Award Video ${index + 3}`}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ borderRadius: 8 }}
                                      />
                                    </div>
                                  );
                                })}
                            </div>
                          </>
                        )}
                      </>
                    )}

                    {data?.past_glimpses && data.past_glimpses.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Past Glimpse</h5>

                        <div className="d-flex flex-wrap gap-3">
                          {data.past_glimpses.map(
                            (event: any, index: number) => (
                              <div
                                key={event._id || index}
                                className="border rounded-3 p-3"
                                style={{ width: 240 }}
                              >
                                {/* EVENT IMAGES */}
                                {event.images && event.images.length > 0 && (
                                  <div className="d-flex flex-wrap justify-content-center gap-2 mb-2">
                                    {event.images.map(
                                      (img: any, imgIndex: number) => (
                                        <img
                                          key={imgIndex}
                                          src={img.image}
                                          alt={`Event ${index + 1} - ${imgIndex + 1
                                            }`}
                                          style={{
                                            width: 90,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 6,
                                          }}
                                        />
                                      ),
                                    )}
                                  </div>
                                )}

                                {/* TITLE */}
                                {event.title && (
                                  <div className="text-center fw-semibold mt-1">
                                    {event.title}
                                  </div>
                                )}

                                {/* DATE */}
                                {event.publishDate && (
                                  <div className="text-center text-muted small">
                                    {event.publishDate}
                                  </div>
                                )}

                                {/* LOCATION */}
                                {event.location && (
                                  <div className="text-center text-muted small">
                                    {event.location}
                                  </div>
                                )}
                              </div>
                            ),
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}
              </Tab>
              <Tab eventKey="past_glimpses" title="Past Glimpses">
                <div className="p-3">
                  {/* ADD BUTTON */}
                  <div className="d-flex justify-content-end mb-3">
                    {pagePermission.canAdd && (
                      <CustomButton
                        label="Add Past Glimpse"
                        isLoading={false}
                        onClick={() => {
                          setPastGlimpseMode("add");
                          seteditingPastGlimpse(null);
                          setshowPastGlimpseModal(true);
                        }}
                        style={{ width: 200 }}
                      />
                    )}
                  </div>

                  {/* NO EVENTS */}
                  {/* {(!data?.events || data.past_glimpses.length === 0) && (
                    <div>No past glimpses found</div>
                  )} */}

                  {/* EVENTS LIST */}
                  {data?.past_glimpses && data.past_glimpses.length > 0 && (
                    <div className="d-flex flex-wrap gap-3">
                      {data.past_glimpses.map((event: any, index: number) => (
                        <div
                          key={index}
                          draggable
                          onDragStart={(e) =>
                            e.dataTransfer.setData(
                              "eventIndex",
                              index.toString(),
                            )
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            const fromIndex = Number(
                              e.dataTransfer.getData("eventIndex"),
                            );
                            reorderPastGlimpse(fromIndex, index);
                          }}
                          className="border rounded p-3 bg-light"
                          style={{
                            width: 320,
                            cursor: "move",
                            background: "#fff",
                          }}
                        >
                          {/* DRAG HANDLE */}
                          <div
                            style={{
                              cursor: "grab",
                              color: "#888",
                              marginBottom: 6,
                            }}
                            title="Drag to reorder"
                          >
                            ⋮⋮
                          </div>

                          {/* IMAGE */}
                          {event.logo && (
                            <img
                              src={event.logo}
                              alt={event.title}
                              style={{
                                width: "100%",
                                height: 140,
                                objectFit: "contain",
                                borderRadius: 6,
                              }}
                              className="mb-2"
                            />
                          )}

                          <strong>{event.title}</strong>

                          {/* ACTIONS */}
                          <div className="d-flex gap-2 mt-2">
                            <PencilFill
                              className="cursor-pointer"
                              onClick={() => {
                                setPastGlimpseMode("edit");
                                seteditingPastGlimpse({ ...event, index });
                                setshowPastGlimpseModal(true);
                              }}
                            />
                            {/* <TrashFill
                              color="#DC143C"
                              className="cursor-pointer"
                              onClick={() => {
                                const updated = data.past_glimpses.filter(
                                  (_: any, i: number) => i !== index
                                );

                                const body = new FormData();
                                body.append(
                                  "past_glimpses",
                                  JSON.stringify(updated)
                                );
                                body.append("id", data._id);

                                WebService.fileUploadAPI({
                                  action: `award/addPastGlimpse`,
                                  body,
                                }).then(() => {
                                  toast.success("Past Glimpses deleted");
                                  getData();
                                });
                              }}
                            /> */}
                            <TrashFill
                              color="#DC143C"
                              className="cursor-pointer"
                              onClick={() => {
                                setDeleteIndex(index);
                                setShowDeleteModal(true);
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </Card>
        {showDeleteModal && (
          <div className="modal fade show d-block" tabIndex={-1}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this past glimpse?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (deleteIndex === null) return;

                      const updated = data.past_glimpses.filter(
                        (_: any, i: number) => i !== deleteIndex,
                      );

                      const body = new FormData();
                      body.append("past_glimpses", JSON.stringify(updated));
                      body.append("id", data._id);

                      WebService.fileUploadAPI({
                        action: `award/addPastGlimpse`,
                        body,
                      }).then(() => {
                        toast.success("Past Glimpse deleted");
                        setShowDeleteModal(false);
                        setDeleteIndex(null);
                        getData();
                      });
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Award;
